<template>
  <el-dialog :title="$t('newApp.Customers.ac')" :visible.sync="dialogVisible" width="70%" class="addUserDialog"
             @close="dialogCloseHandle"
  >
    <div class="ordinaryMode" v-show="modeSwitch">
      <div class="searchBar clear">
        <div class="inputBox">
          <el-input type="text" :placeholder="$t('newApp.Customers.pecnpci')" v-model="customerName"
                    @keyup.enter.native="searchBtn"
          >
            <el-button type="primary" slot="append" @click="searchBtn">
              <i class="iconfont icon-sousuo-icon" />
            </el-button>
          </el-input>
        </div>
      </div>
      <commonTable ref="addUserDialogTable" :data-filter-method="dataFilterMethod">
        <template #buttons>
          <el-button type="primary" @click="batchAddHandlen">{{ $t('btn.Submit') }}</el-button>
        </template>
      </commonTable>
    </div>
    <div class="customMode" v-show="!modeSwitch">
      <div class="btns" @click="companyQueryBtn">
        <img src="@/assets/images/tinyanchalogo.png">
        <span>{{ $t('newApp.Customers.tctftrcn') }}</span>
      </div>
      <el-form class="common_form" label-position="left" ref="addUserForm" :rules="rules" label-width="170px"
               :model="formData"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.CustomerName')" prop="clientName">
              <el-select v-model="formData.clientName" allow-create filterable remote :placeholder="$t('general.peak')"
                         :remote-method="remoteMethod" :loading="loading" @change="clientNameChange"
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.ci')" prop="isChannel">
              <el-select v-model="formData.isChannel" :placeholder="$t('general.ps')" @change="identityChange">
                <el-option v-for="(item, index) in isChannelList" :key="index" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.bon')" prop="opportunityName">
              <!-- <el-input v-model="formData.businessChance" /> -->
              <el-select v-model="formData.opportunityName" clearable :placeholder="$t('general.ps')"
                         @change="opportunityNameChange" multiple collapse-tags
              >
                <el-option v-for="(item, index) in businessList" :key="index" :label="item.opportunityName"
                           :value="item.opportunityName"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.newBusOpp')" prop="newBusOpp">
              <el-radio-group v-model="formData.newBusOpp">
                <el-radio :label="1">{{ $t('general.yes') }}</el-radio>
                <el-radio :label="0">{{ $t('general.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.ccon')" prop="name">
              <el-input v-model="formData.name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.ADList.ContactNumber')" prop="telephone">
              <el-input v-model="formData.telephone" />
            </el-form-item>
          </el-col>
          <template v-if="formData.isChannel !== $t('general.Client') && formData.isChannel !== $t('general.Channel')">
            <!-- 联系人类别 -->
            <el-col :span="12" v-if="formData.isChannel === $t('general.Client')">
              <el-form-item :label="$t('newApp.Customers.ccat')" prop="entityType">
                <el-select v-model="formData.entityType" :placeholder="$t('general.ps')">
                  <el-option v-for="(item, index) in entityTypeList" :key="index" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 圈子名称 -->
            <el-col :span="12" v-if="formData.isChannel === $t('general.Client')">
              <el-form-item :label="$t('newApp.Customers.noc')">
                <el-input v-model="formData.circleName" />
              </el-form-item>
            </el-col>
            <!-- 渠道签约类型 -->
            <el-col :span="12" v-if="formData.isChannel === $t('general.Channel')">
              <el-form-item :label="$t('newApp.Customers.cst')" prop="channelContractType">
                <el-input v-model="formData.channelContractType" />
              </el-form-item>
            </el-col>
            <!-- 是否共建 -->
            <el-col :span="12" v-if="formData.isChannel === $t('general.Channel')">
              <el-form-item :label="$t('newApp.Customers.wtb')" prop="coconstructionOrNot">
                <el-select v-model="formData.coconstructionOrNot" :placeholder="$t('general.ps')">
                  <el-option :label="$t('newApp.Customers.cb')" :value="$t('newApp.Customers.cb')" />
                  <el-option :label="$t('newApp.Customers.ncc')" :value="$t('newApp.Customers.ncc')" />
                </el-select>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer" v-show="!modeSwitch">
      <el-button plain @click="modeSwitch = !modeSwitch" v-show="!editData.clientName">
        {{ $t('btn.Cancel') }}
      </el-button>
      <el-button type="primary" @click="customAddHandle">{{ $t('btn.OK') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { newApplicationFormApi } from '../../service';
import { waitingProcessingApi } from '@/views/privateSeaPool/service';
import { mapState } from 'vuex';
import { isNotEmpty } from '@/utils/utils';
import { confirmPrecheck, notifyDetectFailed } from '@/utils/exportComplianceDialog';

export default {
  data () {
    return {
      rules: {
        clientName: [
          { required: true, message: this.$t('newApp.Customers.pecn'), trigger: ['blur', 'change'] }
        ],
        isChannel: [
          { required: true, message: this.$t('newApp.Customers.psci'), trigger: 'change' }
        ],
        // businessChance: [
        //   { required: true, message: this.$t('newApp.Customers.peabon'), trigger: 'blur' }
        // ],
        // opportunityName: [
        //   { required: true, message: this.$t('newApp.Customers.peabon'), trigger: 'blur' }
        // ],
        // name: [
        //   { required: true, message: this.$t('newApp.Customers.pecc'), trigger: 'blur' }
        // ],
        entityType: [
          { required: true, message: this.$t('newApp.Customers.psacc'), trigger: 'change' }
        ],
        channelContractType: [
          { required: false, message: this.$t('newApp.Customers.pecst'), trigger: 'blur' }
        ],
        coconstructionOrNot: [
          { required: false, message: this.$t('newApp.Customers.pswtb'), trigger: 'change' }
        ]
      },
      formData: {
        circleName: '',
        isChannel: this.$t('general.Client')
      },
      dialogVisible: false,
      modeSwitch: true,
      customerName: '',
      tableData: [],
      customFalge: false,
      businessList: [],
      clientNameList: [],
      options: [],
      value: [],
      list: [],
      loading: false,
      isChannelList: [this.$t('general.Client'), this.$t('general.Channel'), this.$t('general.media'), this.$t('general.Rjis')],
      entityTypeList: [this.$t('general.fd'), this.$t('general.cp'), this.$t('general.Other')],
      dataFilterMethod: null,
      businessChanceLoading: false,
      // 存储查询到的数据
      moreData: {}
    };
  },
  props: {
    addUserDialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTable
  },
  computed: {
    ...mapState({
      salerData: (state) => state.newApplication.salerData
    })
  },
  watch: {
    addUserDialogVisible (val) {
      if (val) {
        if (this.editData.clientName) {
          this.modeSwitch = false;
          this.formData = { ...JSON.parse(JSON.stringify(this.editData)), opportunityName: this.editData.businessChanceList };
        } else {
          this.loadTable();
          this.getTableData();
        }
      } else {
        this.$refs.addUserDialogTable.clearCheckboxReserve();
        this.modeSwitch = true;
        this.customerName = '';
        this.formData = {
          circleName: '',
          isChannel: this.$t('general.Client')
        };
        this.tableData = [];
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    clientNameChange (e) {
      const params = {
        customerName: e,
        checkType: 'LIKE',
        pageSize: 1,
        pageNum: 1,
        tid: 'API_MARKET_CRM_ACCOUNT'
      };
      newApplicationFormApi.getCustomerList(params).then(res => {
        this.moreData = {};
        if (res.status === '200') {
          if (isNotEmpty(res.data.data)) {
            const index = res.data.data.findIndex(item => item.name === e);
            if (index !== -1) {
              this.$set(this.formData, 'customerSaveId', res.data.data[index].id);
              this.getBusinessName(res.data.data[index].id);
              this.moreData = res.data.data[index];
            } else {
              this.businessList = [];
              this.$set(this.formData, 'opportunityName', []);
              this.$set(this.formData, 'opportunityCode', '');
            }
          } else {
            this.businessList = [];
            this.$set(this.formData, 'opportunityName', []);
            this.$set(this.formData, 'opportunityCode', '');
          }
        }
      }).catch(() => {
        this.moreData = {};
      });
    },
    getBusinessName (id) {
      if (id) {
        this.businessList = [];
        this.businessChanceLoading = true;
        this.loadTable();
        newApplicationFormApi.getBusinessName(id).then(res => {
          this.businessChanceLoading = false;
          if (res.status === '200') {
            // res.data.data.forEach(item => {
            //   item.opportunityCode = item.opportunityNumber
            //   item.opportunityName = item.name
            // })
            this.businessList = res.data.data;
            this.businessList.forEach(item => {
              this.$set(item, 'opportunityCode', item.opportunityNumber);
              this.$set(item, 'opportunityName', item.name);
            });
            this.loadTable();
          }
        });
      }
    },
    opportunityNameChange (e) {
      // const currentData = this.businessList.find(item => item.opportunityName === e);
      const currentData = e.map(item => {
        const r = this.businessList.find(i => i.opportunityName === item);
        return r ? r.opportunityCode : '';
      });
      // this.$set(this.formData, 'opportunityCode', currentData.opportunityNumber);
      this.$set(this.formData, 'opportunityCode', currentData.join(','));
    },
    identityChange (val) {
      if (val === this.$t('general.Channel')) {
        this.$set(this.formData, 'circleName', '');
        this.$set(this.formData, 'entityType', '');
        this.$set(this.formData, 'businessChance', '');
      } else {
        this.$set(this.formData, 'coconstructionOrNot', '');
        this.$set(this.formData, 'channelContractType', '');
      }
      this.$nextTick(() => {
        this.$refs.addUserForm.clearValidate();
      });
    },
    companyQueryBtn () {
      if (this.formData.clientName) {
        window.open(`https://www.tianyancha.com/search?key=${this.formData.clientName}`);
      } else {
        window.open(`https://www.tianyancha.com`);
      }
    },
    // 自定义单行添加
    customAddHandle () {
      this.$refs['addUserForm'].validate((valid) => {
        if (valid) {
          let params = {
            tid: 'API_MARKET_CRM_ACCOUNT',
            checkType: 'ACCURATE',
            customerName: this.formData.clientName,
            // 2025年7月28日修改，后端要求新增时去除salerId内容
            // salerId: this.salerData.userId,
            pageSize: 10,
            pageNum: 1
          };
          this.$store.commit('setSubPageLoading', true);
          newApplicationFormApi.getCustomerList(params).then(res => {
            this.$store.commit('setSubPageLoading', false);
            if (res.status === '200') {
              let { data } = res.data;
              let columnName = '';
              if (data && data.length > 0) {
                columnName = data[0].columnName;
              } else {
                columnName = this.formData.isChannel === this.$t('general.Channel') ? this.$t('general.msch') : this.$t('general.mscu');
              }
              if (this.moreData.isChannel !== '1') {
                this.$set(this.moreData, 'output', '--');
              }
              const moreData = JSON.parse(JSON.stringify(this.moreData));
              const formData = JSON.parse(JSON.stringify(this.formData));
              if (moreData.isOldAccount) {
                delete formData.isOldAccount;
              }
              // 删除下拉选择数据name的数据
              if (!formData.name) {
                delete moreData.name;
              }
              let returnVal = [{
                ...moreData,
                ...formData,
                matchResult: data.length > 0 ? 'CRM' : this.$t('general.md'),
                columnName,
                recordType: 'invite',
                opportunityName: formData.opportunityName?.join(','),
                businessChanceList: formData.opportunityName
              }];
              newApplicationFormApi.verificationCustomer(returnVal).then(res => {
                confirmPrecheck(this, res).then(confirmed => {
                  if (!confirmed) return;
                  if (this.editData.clientName) {
                    this.$emit('editUserListHandlen', returnVal);
                  } else {
                    this.$emit('addUserListHandlen', returnVal);
                  }
                });
              }).catch(() => {
                notifyDetectFailed(this);
              });
            }
          });
        }
      });
    },
    // 批量添加
    batchAddHandlen () {
      let checkedData = [
        ...this.$refs.addUserDialogTable.getCheckboxRecords(),
        ...this.$refs.addUserDialogTable.getCheckboxReserveRecords()
      ];
      if (checkedData.length < 1) {
        this.$message.error(this.$t('newApp.Customers.psac'));
        return;
      }
      let returnVal = checkedData.map(item => {
        // return {
        //   clientName: item.name,
        //   matchResult: 'CRM',
        //   businessChance: item.businessChance,
        //   businessChanceCode: item.businessChanceCode,
        //   recordType: 'invite'
        // };
        return {
          ...item,
          clientName: item.name,
          name: item.contactName,
          recordType: 'invite',
          opportunityName: item.businessChanceList?.join(',')
        };
      });
      const isEmpty = returnVal.some(item => item.businessChanceList?.length <= 0 || (item.newBusOpp !== 0 && item.newBusOpp !== 1));
      const leftE = returnVal.some(item => item.businessChanceList?.length <= 0);
      const rightE = returnVal.some(item => item.newBusOpp !== 0 && item.newBusOpp !== 1);
      if (isEmpty) {
        let content = '';
        if (leftE && rightE) {
          content = this.$t('notic.addUserErrA');
        } else if (leftE) {
          content = this.$t('notic.addUserErrB');
        } else {
          content = this.$t('notic.addUserErrC');
        }
        this.$confirm(content, this.$t('general.Hint'), {
          confirmButtonText: this.$t('btn.OK'),
          cancelButtonText: this.$t('btn.Cancel'),
          type: 'warning'
        }).then(() => {
          this.insertVerificationCustomer(returnVal);
        }).catch(() => {
        });
      } else {
        this.insertVerificationCustomer(returnVal);
      }
    },
    // 提取添加请求
    insertVerificationCustomer (returnVal) {
      newApplicationFormApi.verificationCustomer(returnVal).then(res => {
        confirmPrecheck(this, res).then(confirmed => {
          if (confirmed) {
            this.$emit('addUserListHandlen', returnVal);
          }
        });
      }).catch(() => {
        notifyDetectFailed(this);
      });
    },
    searchBtn () {
      let params = {
        tid: 'API_MARKET_CRM_ACCOUNT',
        checkType: 'LIKE',
        customerName: this.customerName
        // salerId: this.salerData.userId
      };
      this.$refs.addUserDialogTable.pageData.pageNum = 1;
      this.$refs.addUserDialogTable.getTableData({ url: '/customer/selection', params: params }).then(res => {
        this.customFalge = res.length < 1;
      });
    },
    switch () {
      this.businessList = [];
      this.modeSwitch = !this.modeSwitch;
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    arrayQuery (val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('50px')
          ._others('checkbox')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.CustomerName'))
          ._data('name')
          ._width('120px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ci'))
          ._width('140px')
          ._data('isChannel')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.catt'))
          ._width('10%')
          ._data('accountMarked')
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._title(this.$t('newApp.Customers.bo'))
      //     ._width('160px')
      //     ._data('businessChance')
      //     ._cellType('customSelect')
      //     ._cellData({
      //       options: this.businessList,
      //       loading: this.businessChanceLoading,
      //       optionProps: {
      //         label: 'name',
      //         value: 'name'
      //       },
      //       multiple: true,
      //       collapseTags: true,
      //       events: {
      //         focus: ({ row }) => {
      //           this.businessList = [];
      //           this.getBusinessName(row.id);
      //         },
      //         change: ({ row }) => {
      //           row.businessChanceCode = this.arrayQuery(row.businessChance, this.businessList, 'name').opportunityNumber;
      //           this.$refs.addUserDialogTable.refreshColumn();
      //         }
      //       }
      //     })
      // );
      /**
       * 更换select加载方式，增加多选功能
       */
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bo'))
          ._width('300px')
          ._data('businessChance')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <el-select
                  v-model={row['businessChanceList']}
                  placeholder={this.$t('newApp.Customers.bo')}
                  multiple
                  collapseTags
                  onChange={(val) => {
                    { /* 将多选转为字符串 */ }
                    row.businessChance = row.businessChanceList.join(',');
                    row.businessChanceCode = this.arrayQuery(val, this.businessList, 'name')?.opportunityNumber || '';
                    this.$refs.addUserDialogTable.refreshColumn();
                  }}
                  onFocus={() => {
                    this.businessList = [];
                    this.getBusinessName(row.id);
                  }}
                >
                  {this.businessList?.map(item => {
                    return <el-option label={item.name} value={item.name} />;
                  })}
                </el-select>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.newBusOpp'))
          ._width('200px')
          ._data('newBusOpp')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <el-radio-group
                  v-model={row['newBusOpp']}>
                  <el-radio label={1}>{this.$t('general.yes')}</el-radio>
                  <el-radio label={0}>{this.$t('general.no')}</el-radio>
                </el-radio-group>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.pdty'))
          ._data('output')
          ._width('180px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cc'))
          ._data('columnName')
          ._width('140px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bc'))
          ._data('mustFollowC')
          ._width('140px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccd'))
          ._data('isOldAccount')
          ._width('190px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccon'))
          ._data('contactName')
          ._width('140px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.ContactNumber'))
          ._data('telephone')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccat'))
          ._data('entityType')
          ._width('140px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cst'))
          ._data('channelContractType')
          ._width('160px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.noc'))
          ._data('circleName')
          ._width('120px')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.wtb'))
          ._data('coconstructionOrNot')
          ._width('140px')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.addUserDialogTable.setColumn(column, {
          rowId: 'index',
          checkboxReserve: true,
          pageMin: true,
          customEmpty: {
            name: 'customEmpty',
            formater: () => {
              let imgUrl = require('@/assets/images/contentNull.png');
              if (this.customFalge) {
                return (
                  <div style="padding: 40px">
                    <img width="300px" src={imgUrl} alt="" />
                    <div style="width: 590px;margin-bottom: 20px;margin-top: 6px;">{this.$t('newApp.Customers.tincmtsc')}</div>
                    <el-button type="primary" onClick={this.switch}>{this.$t('newApp.Customers.ca')}</el-button>
                  </div>
                );
              } else {
                return (
                  <div style="padding: 40px">
                    <img width="300px" src={imgUrl} alt="" />
                    <div style="width: 580px;margin-bottom: 20px;margin-top: 6px;">{this.$t('newApp.Customers.nd')}</div>
                  </div>
                );
              }
            }
          }
        });
      });
    },
    getTableData () {
      this.$nextTick(() => {
        let params = {
          tid: 'API_MARKET_CRM_ACCOUNT',
          checkType: 'LIKE',
          customerName: this.customerName,
          salerId: this.salerData.userId
        };
        this.$refs.addUserDialogTable.loadTable({
          url: '/customer/selection',
          listKey: 'data',
          params
        });
      });
    },
    getCustomerList () {
      let params = {
        tid: 'API_MARKET_CRM_ACCOUNT',
        checkType: 'LIKE',
        customerName: this.customerName,
        pageSize: this.pageData.pageSize,
        pageNum: this.pageData.pageIndex,
        salerId: this.salerData.userId
      };
      newApplicationFormApi.getCustomerList(params).then(res => {
        if (res.status === '200') {
          this.tableData = res.data.data;
          this.customFalge = res.data.data.length < 1;
          this.loadTable();
        }
      });
    },
    // getBusinessName(id) {
    //   if (id) {
    //     this.businessList = [];
    //     this.businessChanceLoading = true;
    //     this.loadTable();
    //     newApplicationFormApi.getBusinessName(id).then(res => {
    //       this.businessChanceLoading = false;
    //       if (res.status === '200') {
    //         this.businessList = res.data.data;
    //         this.loadTable();
    //       } else {
    //         /**
    //          * 2025年7月23日 14点21分
    //          * 增加else处理接口错误无返回数据时一直处于加载中状态的问题
    //          * [测试数据]稍微删除
    //          */
    //         this.businessList = [
    //           {
    //             name: '湖南省儿童医院管理平台项目',
    //             opportunityNumber: '123'
    //           },
    //           {
    //             name: '广东省湛江机电学校云课堂建设项目',
    //             opportunityNumber: '456'
    //           }
    //         ]
    //         this.loadTable();
    //       }
    //     })
    //   }
    // },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        waitingProcessingApi.getUnitList(query).then(res => {
          this.loading = false;
          this.options = res.data.map(item => {
            return { value: `${item}`, label: `${item}` };
          });
        });
      } else {
        this.options = [];
      }
    },
    getClientNameList () {
      waitingProcessingApi.getUnitList().then(res => {
        this.clientNameList = res.data.map(item => {
          return { value: `${item}`, label: `${item}` };
        });
      });
    }

  },
  mounted () {
    this.getClientNameList();
    this.dataFilterMethod = (list) => {
      return list.map(item => {
        let isOldAccount = '--';
        // 当年是否产出字段处理：如果有值则是， 客户身份如果是客户，则值为'--'
        let output = item.output && item.output > 0 ? this.$t('general.yes') : this.$t('general.no');
        if (item.isChannel !== '1') {
          // 客户类别明细字段处理
          const oldAccountList = [this.$t('general.yes'), this.$t('general.Ocus')];
          const filterList = [null, undefined, 'undefined'];
          if (!filterList.includes(item.isOldAccount)) {
            isOldAccount = oldAccountList.includes(item.isOldAccount) ? this.$t('general.Ocus') : this.$t('general.Ncus');
          } else {
            if (item.columnName === '营销系统客户') {
              isOldAccount = '--';
            } else {
              isOldAccount = this.$t('general.Ncus');
            }
          }
          output = '--';
        }

        return {
          ...item,
          output,
          bigArea: item.province,
          area: item.city,
          province: '',
          city: '',
          channelContractType: item.channelContractType === 'null' ? '' : item.channelContractType,
          coconstructionOrNot: item.coconstructionOrNot === 'null' ? '' : item.coconstructionOrNot,
          isChannel: item.isChannel === '1' ? this.$t('general.Channel') : item.isChannel === '0' ? this.$t('general.Client') : '',
          isOldAccount
        };
      });
    };
  }

};
</script>

<style lang="scss" scoped>
.addUserDialog {
  .ordinaryMode {
    >.searchBar {
      width: 100%;
      margin-bottom: 20px;

      >.inputBox {
        width: 100%;

        ::v-deep>.el-input {
          >.el-input-group__append {
            background: #14937B;
            cursor: pointer;
            border: none;
            padding: 0;

            >button {
              display: block;
              min-width: 60px;
              height: 100%;
              padding: 0 !important;
              margin: 0;

              i {
                font-size: 14px;
                color: #ffffff;
                margin: 0;
              }
            }
          }
        }
      }
    }
  }

  .customMode {
    >.btns {
      width: 360px;
      margin-bottom: 20px;
      cursor: pointer;

      >img,
      span {
        display: inline-block;
        vertical-align: middle;
      }

      >span {
        margin-left: 6px;
        color: #12927A;
      }
    }

    ::v-deep>.el-form {
      margin-bottom: 10px;

      >.row {
        >.el-form-item {
          margin-bottom: 20px;

          .el-form-item__label {
            width: 120px;
          }

          .el-form-item__content {
            width: 300px;
            margin-left: 120px !important;
            margin-right: 50px;
          }
        }
      }
    }
  }
}
</style>
